<template>
  <div class="min-box">
    <div class="box-title clearfix">
      <div class="pull-left titleicon"></div>
      <div class="pull-left title-name">{{titleName}}</div>
      <div class="pull-right title-operation">
        <div class="time-choose clearfix" v-if="chooseType">
          <div class="pull-left time-type active" @click="chooseDataType('year')">年</div>
          <div class="pull-left time-type" @click="chooseDataType('month')">月</div>
          <div class="pull-left time-type" @click="chooseDataType('day')">日</div>
        </div>
        <a class="link-more" :href="linkurl" v-if="linkurl" @click="showWindow">{{linkname}}</a>
      </div>
    </div>
    <div class="box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
  },
  props: ['titleName', 'chooseType', 'linkurl', 'linkname'],
  name: "minBox",
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([
    ]),
    chooseDataType(type) {
      this.$emit('chType', { type: type, chooseType: this.chooseType });
    },
    showWindow() {
      this.$emit('more', true);
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
    ])
  },
  created() {
  },
  mounted() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../assets/scss/common.scss";
.min-box {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: rgba(0, 29, 60, .8);
  overflow: hidden;
  .box-title {
    width: 100%;
    line-height: 48px;
    padding: 0 16px;
    background-image: linear-gradient(to right, #2299c5, #0d4f78);
    // background-image: linear-gradient(to right, #23a7c0, transparent);
  }
  .titleicon {
    width: 16px;
    height: 48px;
    background: url('../../public/images/title_icon.png') no-repeat center/contain;
  }
  .title-name {
    padding-left: 14px;
    font-weight: bold;
    font-size: 20px;
    // color: $blue
    color: $white;
  }
  .box-content {
    width: 100%;
    height: calc(100% - 48px);
    padding: 0 16px;
    box-sizing: border-box;
  }
  .time-choose {
    width: 120px;
    margin-top: 12px;
    border-radius: 2px;
    border: 1px solid #2299c6;
    background-color: #093352;
    overflow: hidden;
  }
  .time-type {
    width: 33.33%;
    color: $white;
    font-size: 14px;
    line-height: 24px;
    border-right: 1px solid #2299c6;
    cursor: pointer;
    &:last-of-type {
      border-right: none;
    }
    &.active {
      background-color: #2299c6;
    }
  }
  .title-operation {
    position: relative;
  }
  .link-more {
    font-size: 14px;
    color: #d7eaf2;
    &:hover {
      color: #3fe8f6;
    }
  }
}
</style>